@if (currReport.hasFilterCards) {
  <div class="report-filter-cards">
    <app-dashboard-cards>
      <app-dashboard-filter-card title="DataSource Type">
        <ng-template>
          <app-lt-multiselect-t
            [data]="dataSourceTypeItems"
            panelWidth=""
            label="DataSource Type"
            textField="description"
            valueField="dataSourceTypeId"
            placeholder="Select Data Source Type..."
          [(ngModel)]="dataSourceItemsSelected"></app-lt-multiselect-t>
        </ng-template>
      </app-dashboard-filter-card>
      <app-dashboard-filter-card title="Destination Endpoints">
        <ng-template>
          <app-lt-multiselect-t
            [data]="destinationEndpointItems"
            panelWidth=""
            textField="displayName"
            valueField="destinationEndpointId"
            placeholder="Select Destination Endpoints..."
          [(ngModel)]="destinationEndpointItemsSelected"></app-lt-multiselect-t>
        </ng-template>
      </app-dashboard-filter-card>
      <app-dashboard-filter-card title="Import Types">
        <ng-template>
          <app-lt-multiselect-t
            [data]="importTypeItems"
            panelWidth=""
            textField="typeDescription"
            valueField="importTypeId"
            placeholder="Select Import Types..."
          [(ngModel)]="importTypeItemsSelected"></app-lt-multiselect-t>
        </ng-template>
      </app-dashboard-filter-card>
      <app-dashboard-filter-card title="Server">
        <ng-template>
          <app-lt-multiselect-t
            [data]="serverItems"
            panelWidth=""
            textField="description"
            valueField="serverId"
            placeholder="Select Servers..."
          [(ngModel)]="serverItemsSelected"></app-lt-multiselect-t>
        </ng-template>
      </app-dashboard-filter-card>
    </app-dashboard-cards>
  </div>
  <div class="report-command-button-group">
    <button type="button" class="btn btn-outline-secondary" (click)="resetFilters()">
      Reset Filters
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="applyFilters()" >
      Apply Filters
    </button>
  </div>
}

@if (currReport.hasSearch) {
  <hr class="hr-solid">
  <div class="row row-cols-1 row-cols-md-2 row-cols-sm-2 pb-3 g-3">
    <div class="col">
      <div class="card search-card h-100">
        <div class="card-body">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="{{xmlSearchTerm.defaultText}}" [(ngModel)]="xmlSearchTerm.searchValue">
            <div class="input-group-append">
              <button matButton="outlined" (click)="updateSearch(xmlSearchTerm)" class="px-1 search-icon-btn">
                <mat-icon class="material-icons-outlined search-icon">search</mat-icon>
              </button>
              <button matButton="outlined" (click)="clearSearch(xmlSearchTerm)" class="px-1 search-icon-btn">
                <mat-icon class="material-icons-outlined search-icon">close</mat-icon>
              </button>
            </div>
          </div>
        </div>
        @if (xmlSearchTerm.hasSearchTerm) {
          <div class="card-footer card-current-search">
            Current Search: {{xmlSearchTerm.currentSearchValue | json}}
          </div>
        }
      </div>
    </div>
    <div class="col">
      <div class="card search-card h-100">
        @if (!jsLoaded) {
          <div class="search-checkbox justify-content-end">
            <mat-checkbox
              [checked]="false"
              (change)="loadJS()"
              [labelPosition]="'before'">
              Load JavaScripts
            </mat-checkbox>
          </div>
        }
        <div class="card-body">
          <div class="input-group">
            <input type="text" class="form-control integJSSearchBox" placeholder="{{jsSearchTerm.defaultText}}" [(ngModel)]="jsSearchTerm.searchValue" [disabled]="!jsLoaded">
            <div class="input-group-append">
              <button matButton="outlined" (click)="updateSearch(jsSearchTerm)" class="px-1 search-icon-btn" [disabled]="!jsLoaded">
                <mat-icon class="material-icons-outlined search-icon">search</mat-icon>
              </button>
              <button matButton="outlined" (click)="clearSearch(jsSearchTerm)" class="px-1 search-icon-btn" [disabled]="!jsLoaded">
                <mat-icon class="material-icons-outlined search-icon">close</mat-icon>
              </button>
            </div>
          </div>
        </div>
        @if (jsSearchTerm.hasSearchTerm) {
          <div class="card-footer card-current-search">
            Current Search: {{jsSearchTerm.currentSearchValue | json}}
          </div>
        }
      </div>
    </div>
  </div>
}

@if (currReport.tableVersion === 0) {
  <!-- Grid without Checkbox column -->
  <div class="report-grid-wrapper">

    <app-lt-png-table #integrationGrid [gridSettingsInput]="integrationGridSettings()"></app-lt-png-table>

  </div>
}
